<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" right="iconrotate" @rightClick="onSelect" />
    <div class="topLock">
      <form action="/">
        <van-search v-model="search.key" placeholder="请输入手机号码" @search="onSelect" @cancel="onSelect" />
      </form>
      <van-dropdown-menu>
        <van-dropdown-item v-model="search.type" :options="optionType" @close="onSelect" />
        <van-dropdown-item v-model="search.verifyType" :options="optionVerifyType" @close="onSelect" />
      </van-dropdown-menu>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="topEmpty" />
      <div v-for="item in list" :key="item.diverCardId" class="rect">
        <van-row>
          <van-col span="4">序号:{{ item.diverCardId }}</van-col>
          <van-col span="8">卡片类型:{{ item.type }}</van-col>
          <van-col span="12" class="textRight">{{ formatDate(item.createTime,"yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>
        <van-row v-if="item.user">
          <van-col span="12">用户:{{ item.user.firstName }} {{ item.user.lastName }}</van-col>
          <van-col span="12" class="textRight">手机:{{ item.user.phone }}</van-col>
        </van-row>
        <van-row>
          <van-col span="8">状态:{{ GetEnumText('Em_DiveCardVerifyType',item.verifyType) }}</van-col>
          <van-col v-if="item.verifyTime" span="16" class="textRight">审核时间:{{ formatDate(item.verifyTime,"yyyy-MM-dd hh:mm:ss",true) }}</van-col>
        </van-row>
        <div v-if="item.verifyBody">审核备注:{{ item.verifyBody }}</div>
        <van-image
          v-for="img in item.imgList"
          :key="img"
          width="8em"
          height="8em"
          alt="cover"
          :src="img"
          @click="onImagePreview(item.imgList)"
        />
        <van-row>
          <van-col span="18"><input v-model="item.why" type="text" placeholder="原因" class="inputRect">
            <van-button type="info" :loading="buttonLoading" @click="onNoPass(item)">不通过</van-button></van-col>
          <van-col span="6" class="textRight"><van-button :loading="buttonLoading" type="primary" @click="onPass(item)">审核通过</van-button></van-col>
        </van-row>
      </div></van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, MyNotify, GetEnumText } from '@/utils/base'
import { Button, List, Image, ImagePreview, DropdownMenu, DropdownItem, Search } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Search.name]: Search,
    TopBar
  },
  data() {
    return {
      buttonLoading: false,
      title: '用户潜水员身份审核',
      backurl: '/users/index',
      list: [],
      error: false,
      loading: false,
      finished: false,
      search: {
        page: 1,
        limit: 30,
        type: undefined,
        verifyType: 'WAIT',
        key: undefined
      },
      optionType: [
        { text: '不限类型', value: undefined },
        { text: '其他', value: 'OTHER' },
        { text: 'SSI', value: 'SSI' }
        // { text: 'PADI电子卡', value: 'EPADI' },
        // { text: 'PADI塑料卡', value: 'PADI' }
      ],
      optionVerifyType: [
        { text: '不限类型', value: undefined },
        { text: '待审核', value: 'WAIT' },
        { text: '审核失败', value: 'CANCEL' },
        { text: '审核通过', value: 'PASS' }
      ]
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.search.page = 1
    this.list = []
    this.onLoad()
  },
  methods: {
    formatDate,
    GetEnumText,
    onLoad() {
      this.loading = true
      request({
        url: '/Activity/getApproveList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        console.log(response)
        this.limit = response.data.limit
        this.page = response.data.page + 1
        response.data.rows.forEach(item => {
          item.imgList = item.resImg.split(',')
          this.list.push(item)
        })
        if (response.data.rows.length < this.limit) {
          this.finished = true
        }
      })
    },
    onSelect() {
      this.search.page = 1
      this.list = []
      this.onLoad()
    },
    onImagePreview(imgs) {
      ImagePreview(imgs)
    },
    onNoPass(item) {
      this.buttonLoading = true
      request({
        url: '/Activity/updateApprove',
        method: 'post',
        data: {
          diverCardId: item.diverCardId,
          verifyType: 'CANCEL',
          verifyBody: item.why
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '已标记审核不通过')
        this.list.forEach((line) => {
          if (line.diverCardId === item.diverCardId) {
            item.verifyBody = item.why
            item.verifyType = 'CANCEL'
            var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
            var tm = new Date().getTime() + utcToLoacl
            item.verifyTime = new Date(tm)
          }
        })
      })
    },
    onPass(item) {
      this.buttonLoading = true
      request({
        url: '/Activity/updateApprove',
        method: 'post',
        data: {
          diverCardId: item.diverCardId,
          verifyType: 'PASS',
          verifyBody: ''
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        item.verifyType = 'PASS'
        var utcToLoacl = new Date().getTimezoneOffset() * 60 * 1000
        var tm = new Date().getTime() + utcToLoacl
        item.verifyTime = new Date(tm)
        MyNotify('success', '已标记审核通过')
      })
    }
  }
}
</script>
<style scoped>
.rect{
    padding: 1em 1em;
    border-bottom: 1px solid #ccc;
    background-color: #Fff;
    margin-bottom: 1em;
}
.inputRect{
    height: 38px;
}
.topEmpty{
    height: 6em;
}
.topLock{
    position: fixed;
    left: 0;
    top: 3em;
    right: 0;
    height: 5em;
    z-index: 10;
}
</style>
